<template>
	<modal
		class="integration-modal"
		size="large"
		@close="close">
		<template slot="header">
			<h3>{{ title }}</h3>
		</template>
		<template
			slot="body">
			<div class="row">
				<!-- TUTORIAL -->
				<div class="col-md-6">
					<h4 class="modal-title">How to Integrate</h4>
					<div class="integration-video embed-responsive embed-responsive-16by9">
						<iframe :src="videoUrl"></iframe>
					</div>
				</div>
				<!-- CONFIG -->
				<div class="col-md-6">
					<h4 class="modal-title">Configurations</h4>
					<div class="integration-explanation text-left mb-3">
						<div class="title">Set your Midtrans SNAP Preference settings:</div>
						<div class="description">
							<i class="material-icons checklist mr-2">check</i>
							<span>Finish URL: {{ finishUrl }}</span>
						</div>
						<div class="description">
							<i class="material-icons checklist mr-2">check</i>
							<span>Unfinish URL: {{ unfinishUrl }}</span>
						</div>
						<div class="description">
							<i class="material-icons checklist mr-2">check</i>
							<span>Error URL: {{ errorUrl }}</span>
						</div>
					</div>
					<div class="integration-actions">
						<!-- Merchant ID -->
						<div class="form-group">
							<label><b>Merchant ID</b></label>
							<input
								type="text"
								class="input form-control"
								placeholder="Midtrans Merchant ID"
								v-model="merchantId"
							/>
						</div>
						<!-- Client Key -->
						<div class="form-group">
							<label><b>Client Key</b></label>
							<input
								type="text"
								class="input form-control"
								placeholder="Midtrans Client Key"
								v-model="clientKey"
							/>
						</div>
						<!-- Server Key -->
						<div class="form-group">
							<label><b>Server Key</b></label>
							<input
								type="text"
								class="input form-control"
								placeholder="Midtrans Server Key"
								v-model="serverKey"
							/>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template slot="footer">
			<button
				type="button"
				class="btn btn-light"
				@click="close">
				Close
			</button>
			<button
				type="button"
				class="input-group-text btn btn-primary"
				:disabled="!isFormValid"
				:class="{ 'is-loading': isSaving }"
				@click="submit">
				<span v-if="!account">Integrate</span>
				<span v-else>Update</span>
			</button>
		</template>
	</modal>

</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import integrationApi from '@/api/integration';
import { duplicateVar, getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'MidtransIntegration',
	props: {
		account: {
			type: Object,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			title: 'Midtrans Integration',
			merchantId: '',
			clientKey: '',
			serverKey: '',
			isSaving: false,
			videoUrl: 'https://www.youtube.com/embed/0jTTXdgilnA?rel=0',
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		setData() {
			if (this.account && this.account.data) {
				const data = duplicateVar(this.account.data);
				this.merchantId = data.merchant_id;
				this.clientKey = data.client_key;
				this.serverKey = data.server_key;
			} else {
				this.initValues();
			}
		},
		initValues() {
			this.merchantId = '';
			this.clientKey = '';
			this.serverKey = '';
		},
		submit() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const account = response.data;
				this.$notify({
					group: 'app',
					title: this.title,
					text: 'Saved Successfully',
					type: 'success',
				});
				this.$emit('insert', account);
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: this.title,
					text: message,
					type: 'error',
				});
				this.isSaving = false;
			};
			if (this.account) {
				integrationApi.updateMidtrans(this.account._id, params, callback, errorCallback);
			} else {
				integrationApi.addMidtrans(params, callback, errorCallback);
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		params() {
			const merchantId = this.merchantId.trim();
			const clientKey = this.clientKey.trim();
			const serverKey = this.serverKey.trim();
			const params = {
				merchant_id: merchantId,
				client_key: clientKey,
				server_key: serverKey,
			};
			return params;
		},
		userUrl() {
			return this.user ? `https://${this.user.username}.ostock.id` : '';
		},
		finishUrl() {
			return `${this.userUrl}/payment/finish`;
		},
		unfinishUrl() {
			return `${this.userUrl}/payment/unfinish`;
		},
		errorUrl() {
			return `${this.userUrl}/payment/error`;
		},
		isFormValid() {
			return this.merchantId !== ''
				&& this.clientKey !== ''
				&& this.serverKey !== '';
		},
	},
	created() {
		this.setData();
	},
};
</script>

<style>

</style>
